import React from 'react';

import useGroupVsRemainderData from './hooks/useGroupVsRemainderData';
import GroupVsRemainderView from './GroupVsRemainderView';

const GroupVsRemainderContent = ({
  gadget,
}: {
  gadget: VisualisationDefinitions.GroupVsRemainder;
}) => {
  const { options, hasResults, compatibleComparison } = useGroupVsRemainderData(
    { gadget },
  );

  return (
    <GroupVsRemainderView
      options={options}
      hasResults={hasResults}
      compatibleComparison={compatibleComparison}
    />
  );
};

export default GroupVsRemainderContent;
